import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import styled from 'styled-components';
import { FieldPermissionFlag } from '../FieldPermissionFlag';

const Error = styled.span`
  font-size: 0.7rem;
  margin: 0;
  width: 100%;

  text-align: left;
  color: #be1e2d;
  display: none;

  animation: fade-in 0.3s ease-in-out both, slide-down 0.3s ease-in-out both;

  &.-visible {
    display: inline-block;
    // using this to position the error message, so that it doesn't push other fields down
    position: absolute;
    bottom: 2px;
    white-space: nowrap;
    @media (min-width: 1000px) {
      bottom: ${props => props.theme.name !== 'gogurt' ? '-8px' : '2px'};
    }
  }
`;

export function FieldError<FieldValue, T extends HTMLElement>(
  props: FieldProps<FieldValue, FieldRenderProps<FieldValue, T>, T>,
): JSX.Element {
  return (
    <FieldPermissionFlag field={props.name as any} renderIf="write">
      <Field name={props.name} subscription={{ touched: true, error: true }}>
        {fieldProps => {
          const { meta } = fieldProps;
          const isVisible = meta.error && meta.touched;
          const id = `${props.name}-error`;

          return (
            <Error
              id={id}
              data-testid={id}
              className={isVisible ? '-visible' : ''}
            >
              {meta.error}
            </Error>
          );
        }}
      </Field>
    </FieldPermissionFlag>
  );
}
